import React, { useState, useEffect } from 'react';
import {
  BackgroundContainer,
  Container,
  ErrorMessage,
  Loader,
} from '@app/components/error-pages/error-page-component';
import { Icon } from '@app/components';
type Props = {
  message?: string;
};
export default function DefaultErroPage({ message }: Props) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <BackgroundContainer>
      <Container>
        {loading ? (
          <Loader>
            <Icon name="loader" />
          </Loader>
        ) : (
          <ErrorMessage>
            {message ? message : 'Something went wrong.Please try again...'}
          </ErrorMessage>
        )}
      </Container>
    </BackgroundContainer>
  );
}
